import { AxiosResponse } from 'axios';
import { call, CallEffect, PutEffect, select } from '@redux-saga/core/effects';
import { automaticApi } from '@/settings/api';
import { Action } from 'redux-saga';
import { getFormattedCart } from '@/utils/functions';
import { getCustomer } from './functions';
import { ReducersTypes } from '@/redux/reducers/Models';
import environment from '@/settings/environment';

export interface Fetch {
  callback: (success: boolean, data?: {
    code?: string;
    image?: string;
    imageType?: string;
    imageWidth?: number;
    codeExpiration?: string;
    idTransaction?: string;
    errorCode?: string;
  }) => void;
}

export interface RechargePixAction {
  type: string;
  payload: Fetch;
}

const uri = "/internalwebapi/v1/payments/pix";

export default function* rechargePix({
  payload,
}: RechargePixAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse<{
    generateImage: {
      imageContent: string;
      mimeType: string;
      actualImageWidth: number;
    }
    textContent: string;
    expirationDate: string;
    status: {
      codigoRetorno: number;
    }
    idTransaction?: string;
    requestId?: string;
    errorCode?: string;
  }, any>
> {
  try {
    // @ts-expect-error
    const customer: ReducersTypes['customerReducer'] = yield select(getCustomer);
    const client = customer?.client;
    const account = customer?.account;

    const { total, selected } = getFormattedCart({
      debts: customer?.debts!,
      cart: customer?.cart?.filter(item => item.checked) ?? [],
    });

    const body = {
      requestId: customer?.requestId!,
      companyIdentification: environment.api.companyIdentification,
      customerIdentification: client?.id!,
      accountIdentification: account?.id!,
      paymentValue: total,
      licensePlate: customer?.selectedVehicles ? customer?.selectedVehicles?.toString() : customer?.vehicles?.[0]?.plate,
      tollPassages: selected
    };

    const response = yield call(automaticApi.post, uri, body);
    const data = response?.data;
    
    // Check if response has error code 422 even with status 200
    if (data?.errorCode === "422") {
      yield call(payload.callback, false, { errorCode: "422" });
      return;
    }
    
    if (data?.status?.codigoRetorno === 0) {
      yield call(
        payload.callback,
        true,
        {
          code: response?.data?.textContent,
          image: response?.data?.generateImage?.imageContent,
          imageType: response?.data?.generateImage?.mimeType,
          imageWidth: response?.data?.generateImage?.actualImageWidth,
          codeExpiration: response?.data?.expirationDate,
          idTransaction: response?.data?.idTransaction || response?.data?.requestId,
        }
      );
    } else {
      yield call(
        payload.callback,
        false
      );
    }
  } catch (error) {
    yield call(
      payload.callback,
      false
    );
  }
}
